module.exports = __webpack_public_path__ + "static/img/banner_业财一体化AI.80271ef6.png";